import { createAsyncThunk } from "@reduxjs/toolkit";
import "react-toastify/dist/ReactToastify.css";

//Include Both Helper File with needed methods
import { formatQueryParams } from "helpers/format";
import couponApi from "api/couponApi";

export const getCouponList = createAsyncThunk(
  "Coupon",
  async (params: any = {}) => {
    try {
      const response = await couponApi.couponList(
        formatQueryParams(params)
      );
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const getCouponActionLogs = createAsyncThunk("CouponActionLog", async (params: any = {}) => {
  try {
    const response = await couponApi.couponActionLogList(formatQueryParams(params));
    return response;
  } catch (error) {
    return error;
  }
});
